<template>
  <div class="box" :class="{ shi: grade == 3 && isshi }">
    <div class="type1" v-if="type === 1">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
        <img
          src="@/assets/image/hetongqianshu/tuijian.webp"
          style="width: 70px; height: 20px"
        />
      </div>
      <div class="right"></div>
    </div>
    <div class="type1 type2" v-if="type === 2">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
        <img
          src="@/assets/image/hetongqianshu/tuijian.webp"
          style="width: 70px; height: 20px"
        />
      </div>
      <div class="right"></div>
    </div>
    <div class="type1 type3" v-if="type === 3">
      <div class="left">
        <div class="title">
          <div class="icon"><i class="el-icon-check"></i></div>
          {{ title }}
        </div>
        <div class="desc">{{ desc }}</div>
      </div>
      <div class="right">
        <el-button type="primary btn2" class="button" plain @click="setStep(4)"
          >修改</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
    isshi: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      title: "合同保障服务",
      num: 3,
    };
  },
  created() {},
  computed: {
    ...mapState("hetongqianshu", ["step"]),
    ...mapState({
      desc: (state) => state.insuranceSelect.title,
      ...mapState("insuranceSelect", ["grade"]),
    }),
  },
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
  },
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/shit/index.scss" as *;
.shi {
  .type1 {
    .title {
      .icon {
        border-color: #ffe9b0;
        color: #ffe9b0;
      }
      color: #ffe9b0;
    }
  }
}
</style>
